export class CheckValidity {
  static readonly type = '[Global] Check Validity'
}

export class ResetState {
  static readonly type = '[Global] Reset State'
}
